export class Person{
  name:string
  email:string
  constructor(name?:string,email?:string){
    if(name){
      this.name = name;
    }
    if(email){
      this.email = email;
    }
  }
}
